import React, { Component } from "react";
import PropTypes from "prop-types";
import * as Formik from "formik";

//Necessary because Formik does rerender all field all the time
class FieldRenderBuffer extends Component {
  // shouldComponentUpdate(nextProps, nextState) {
  //   //Todo 24-9-2018: Look at this because array comparisons don't work because the array object is not cloned?
  //   // if (this.props.showErrors !== nextProps.showErrors) return true
  //   // if (this.props.errorMessage !== nextProps.errorMessage) return true
  //   // if (this.props.isRequired !== nextProps.isRequired) return true
  //   // const field = this.props.formikField
  //   // const nextField = nextProps.formikField
  //   // //console.log(this.props, nextProps)
  //   // //console.log(this.state, nextState)
  //   // if (field.name && field.value instanceof Array && field.value.length !== nextField.value.length) return true
  //   // //console.log(field.value.length, nextField.value.length)
  //   // if (field.name && field.value !== nextField.value) return true
  //   return true
  // }

  render() {
    //console.log('Render field ', this.props.type)
    return this.props.children;
  }
}

export default class Field extends Component {
  static propTypes = {
    config: PropTypes.object.isRequired,
    step: PropTypes.object.isRequired,
    template: PropTypes.any.isRequired,
  };

  render() {
    const { form, config } = this.props;
    const { name } = config;

    return (
      <Formik.Field
        name={name}
        render={(formik) => {
          return this.renderField(formik.field, formik.form, form);
        }}
      />
    );
  }

  renderField(formikField, formikForm, form) {
    const { config, step } = this.props;
    const { type, name, validation } = config;
    const Template = this.props.template; // Capitalized to enable React Component rendering

    if (!config.name) {
      console.error(
        `The field "${
          config.label || type || config.name
        }" is missing a unique "name" property`,
        config
      );
      return null;
    }

    const isTouched = !!formikForm.touched[name];
    const showErrors =
      (isTouched && formikForm.errors[name]) ||
      (!isTouched && config.errorMessage);
    const errorMessage =
      !isTouched && config.errorMessage
        ? config.errorMessage
        : formikForm.errors[name] || "";

    return (
      <FieldRenderBuffer type={config.type} formikField={formikField}>
        <Template
          config={config}
          step={step}
          formikField={formikField}
          formikForm={formikForm}
          form={form}
          showErrors={showErrors}
          errorMessage={errorMessage}
          isRequired={
            validation && validation.rules
              ? validation.rules
                  .map((item) => item.type === "required")
                  .includes(true)
              : false
          }
        />
      </FieldRenderBuffer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Form/Field.js